<mat-card class="courses-card mb-0">
  <app-card-header [title]="data.title" [icon]="data.icon" />

  <mat-card-content>
    <div class="row">
      <div class="col my-courses-col">
        <app-courses-list [pageData]="data" />
      </div>

      <div class="col useful-links-col">
        <app-useful-links class="useful-links" [title]="data.usefulLinksTitle" [links]="data.usefulLinks" />
      </div>
    </div>
  </mat-card-content>
</mat-card>
